<template>
  <div>
    <el-form
      :model="form"
      productSize="small"
      :inline="true"
      label-width="100px"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="类别：">
            <!-- <el-input v-model="form.categoryName" @keyup.enter.native="onSubmit" :controls="false"></el-input> -->
            <el-autocomplete
              class="form-input"
              v-model="form.categoryName"
              :fetch-suggestions="querySkuList"
              @keyup.enter.native="onSubmit"
              @focus="onSkuCodeFocus(5)"
            ></el-autocomplete>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <div><span class="text-buttom">常用选项</span></div>
        <el-col>
          <el-button
            type="whiteBackground"
            v-for="(item, index) in optionsn.category.commonlyUsed"
            :key="item.criteriaContent"
            :class="` backPlay ${colorIndex.categoryName === index && form.categoryName ? 'colorType' : ''}`"
            @click="searchName(item, index)"
            >{{ item.criteriaContent }}</el-button
          >
        </el-col>
      </el-row>
      <el-row v-if="form.categoryName == '沙发' || form.categoryName == '衣柜'">
        <el-col :span="24">
          <el-form-item label="规格：">
            <!-- <el-input v-model="form.categoryName" @keyup.enter.native="onSubmit" :controls="false"></el-input> -->
            <el-autocomplete
              class="form-input"
              v-model="form.specDesc"
              :fetch-suggestions="querySkuList"
              @keyup.enter.native="onSubmit"
              @focus="onSkuCodeFocus(10)"
            ></el-autocomplete>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="form.categoryName == '沙发'">
        <div><span class="text-buttom">常用选项</span></div>
        <el-col>
          <el-button
            :type="`${!item.useFlag ? 'whiteBackground' : '' }`"
            v-for="(item, index) in optionsn.sofaSpec.commonlyUsed"
            :key="item.criteriaContent"
            :class="`${!item.useFlag ? 'backPlay' : '' } ${colorIndex.specDesc === index && form.specDesc ? 'colorType' : ''}`"
            @click="searchName(item, index)"
            :disabled="item.useFlag"
            >{{ item.criteriaContent }}</el-button
          >
        </el-col>
      </el-row>
      <el-row v-if="form.categoryName == '衣柜'">
        <div><span class="text-buttom">常用选项</span></div>
        <el-col>
          <el-button
            :type="`${!item.useFlag ? 'whiteBackground' : '' }`"
            v-for="(item, index) in optionsn.wardrobeSpec.commonlyUsed"
            :key="item.criteriaContent"
            :class="`${!item.useFlag ? 'backPlay' : '' } ${colorIndex.specDesc === index && form.specDesc ? 'colorType' : ''}`"
            @click="searchName(item, index)"
            :disabled="item.useFlag"
            >{{ item.criteriaContent }}</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="form-number-input">
            <el-form-item label="日常活动到手价：">
              <el-input
                v-model.number="form.saleAmountStart"
                @keyup.enter.native="onSubmit"
                :controls="false"
              ></el-input>
            </el-form-item>
            <el-form-item label="~" class="date-number-middle">
              <el-input
                v-model.number="form.saleAmountEnd"
                :controls="false"
              ></el-input>
            </el-form-item>
          </span>
        </el-col>
      </el-row>
      <el-row>
        <div><span class="text-buttom">常用选项</span></div>
        <el-col>
          <el-button
            :type="`${!item.useFlag ? 'whiteBackground' : '' }`"
            v-for="(item, index) in optionsn.price.commonlyUsed"
            :key="item.criteriaContent"
            :class="`${!item.useFlag ? 'backPlay' : '' } ${colorIndex.saleAmountEnd === index && form.saleAmountStart ? 'colorType' : ''}`"
            @click="searchName(item, index)"
            :disabled="item.useFlag"
            >{{ item.criteriaContent }}</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="风格：">
            <!-- <el-input v-model="form.style" :controls="false" @keyup.enter.native="onSubmit" :disabled="disabledStyle"></el-input> -->
            <el-autocomplete
              class="form-input"
              v-model="form.style"
              :disabled="disabledStyle"
              :fetch-suggestions="querySkuList"
              @keyup.enter.native="onSubmit"
              @focus="onSkuCodeFocus(4)"
            ></el-autocomplete>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <div><span class="text-buttom">常用选项</span></div>
        <el-col>
          <el-button
            :type="`${!item.useFlag ? 'whiteBackground' : '' }`"
            v-for="(item, index) in optionsn.style.commonlyUsed"
            :key="item.criteriaContent"
            :class="`${!item.useFlag ? 'backPlay' : '' } ${colorIndex.style === index && form.style ? 'colorType' : ''}`"
            @click="searchName(item, index)"
            :disabled="item.useFlag"
            >{{ item.criteriaContent }}</el-button
          >
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="24">
          <el-form-item label="长：">
            <el-autocomplete
              class="form-input"
              v-model="form.length"
              :fetch-suggestions="querySkuList"
              @keyup.enter.native="onSubmit"
              @focus="onSkuCodeFocus(7)"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="宽：">
            <el-autocomplete
              class="form-input"
              v-model="form.width"
              :fetch-suggestions="querySkuList"
              @keyup.enter.native="onSubmit"
              @focus="onSkuCodeFocus(8)"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="高：">
            <el-autocomplete
              class="form-input"
              v-model="form.height"
              :fetch-suggestions="querySkuList"
              @keyup.enter.native="onSubmit"
              @focus="onSkuCodeFocus(9)"
            ></el-autocomplete>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row>
        <el-col :span="24">
          <el-form-item label="长：">
            <el-autocomplete
              class="form-input"
              v-model="form.lengthUpper"
              :fetch-suggestions="querySkuList"
              @keyup.enter.native="onSubmit"
              @focus="onSkuCodeFocus(7)"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="至" label-width="30px !important">
            <el-autocomplete
              class="form-input"
              v-model="form.lengthLower"
              :fetch-suggestions="querySkuList"
              @keyup.enter.native="onSubmit"
              @focus="onSkuCodeFocus(7)"
            ></el-autocomplete>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="宽：">
            <el-autocomplete
              class="form-input"
              v-model="form.widthUpper"
              :fetch-suggestions="querySkuList"
              @keyup.enter.native="onSubmit"
              @focus="onSkuCodeFocus(8)"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="至" label-width="30px !important">
            <el-autocomplete
              class="form-input"
              v-model="form.widthLower"
              :fetch-suggestions="querySkuList"
              @keyup.enter.native="onSubmit"
              @focus="onSkuCodeFocus(8)"
            ></el-autocomplete>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="高：">
            <el-autocomplete
              class="form-input"
              v-model="form.heightUpper"
              :fetch-suggestions="querySkuList"
              @keyup.enter.native="onSubmit"
              @focus="onSkuCodeFocus(9)"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="至" label-width="30px !important">
            <el-autocomplete
              class="form-input"
              v-model="form.heightLower"
              :fetch-suggestions="querySkuList"
              @keyup.enter.native="onSubmit"
              @focus="onSkuCodeFocus(9)"
            ></el-autocomplete>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="颜色：">
            <!-- <el-input v-model="form.color" :controls="false" :disabled="disabledColor"></el-input> -->
            <el-autocomplete
              class="form-input"
              v-model="form.color"
              :disabled="disabledColor"
              @keyup.enter.native="onSubmit"
              :fetch-suggestions="querySkuList"
              @focus="onSkuCodeFocus(2)"
            ></el-autocomplete>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <div><span class="text-buttom">常用选项</span></div>
        <el-col>
          <el-button
            :type="`${!item.useFlag ? 'whiteBackground' : '' }`"
            v-for="(item, index) in optionsn.color.commonlyUsed"
            :key="item.criteriaContent"
            :class="`${!item.useFlag ? 'backPlay' : '' } ${colorIndex.color === index && form.color ? 'colorType' : ''}`"
            @click="searchName(item, index)"
            :disabled="item.useFlag"
            >{{ item.criteriaContent }}</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="功能：">
            <!-- <el-input v-model="form.functionality" @keyup.enter.native="onSubmit" :controls="false"></el-input> -->
            <el-autocomplete
              class="form-input"
              v-model="form.functionality"
              @keyup.enter.native="onSubmit"
              :fetch-suggestions="querySkuList"
              @focus="onSkuCodeFocus(6)"
            ></el-autocomplete>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <div><span class="text-buttom">常用选项</span></div>
        <el-col>
          <el-button
            :type="`${!item.useFlag ? 'whiteBackground' : '' }`"
            v-for="(item, index) in optionsn.functionality.commonlyUsed"
            @click="searchName(item, index)"
            :class="`${!item.useFlag ? 'backPlay' : '' } ${colorIndex.functionality === index && form.functionality ? 'colorType' : ''}`"
            :key="item.criteriaContent"
            :disabled="item.useFlag"
            >{{ item.criteriaContent }}</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="材质：">
            <!-- <el-input v-model="form.material" :controls="false"></el-input> -->
            <el-autocomplete
              class="form-input"
              v-model="form.material"
              @keyup.enter.native="onSubmit"
              :fetch-suggestions="querySkuList"
              @focus="onSkuCodeFocus(3)"
            ></el-autocomplete>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <div><span class="text-buttom">常用选项</span></div>
        <el-col>
          <el-button
            :type="`${!item.useFlag ? 'whiteBackground' : '' }`"
            v-for="(item, index) in optionsn.material.commonlyUsed"
            @click="searchName(item, index)"
            :key="item.criteriaContent"
            :class="`${!item.useFlag ? 'backPlay' : '' } ${colorIndex.material === index  && form.material? 'colorType' : ''}`"
            :disabled="item.useFlag"
            >{{ item.criteriaContent }}</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div style="display: flex; align-items: center" class="province">
            <el-form-item label="地域：">
              <!-- <el-input v-model="form.province" :controls="false"></el-input> -->
              <!-- <el-autocomplete
              class="form-input"
              v-model="form.province"
              @keyup.enter.native="onSubmit"
              :fetch-suggestions="querySkuList"
              @focus="onSkuCodeFocus(4)"
            ></el-autocomplete> -->
              <el-select
                v-model="form.province"
                collapse-tags
                reserve-keyword
                filterable
                multiple
              >
                <!-- <el-option label="全部" value="" /> -->
                <el-option
                  v-for="item in optionsn.area.commonlyUsed"
                  :label="item.criteriaContent"
                  :key="item.criteriaContent"
                  :value="item.criteriaContent"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-link
              type="primary"
              style="line-height: 40px"
              :underline="false"
              @click="more"
              >{{ moreOptions ? "收起" : "更多筛选项" }}</el-link
            >
          </div>
        </el-col>
      </el-row>
      <el-row v-if="moreOptions">
        <el-col :span="24">
          <div style="padding: 0 0 20px 100px">
            <el-card class="box-card">
              <el-form-item label="" prop="spuName" class="checkbox">
                <el-checkbox-group v-model="form.province">
                  <el-checkbox
                    v-for="item in optionsn.area.commonlyUsed"
                    :label="item.criteriaContent"
                    :key="item.criteriaContent"
                    >{{ item.criteriaContent }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>
            </el-card>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="form-date-picker">
            <el-form-item label="付款时间：">
              <el-date-picker
                @change="work"
                v-model="form.payTimeStart"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                :clearable="timeType ? false : true"
                :editable="timeType ? false : true"
                :picker-options="timeType ? pickerOptions : timeNone"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="至" class="date-picker-middle">
              <el-date-picker
                v-model="form.payTimeEnd"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                :editable="timeType ? false : true"
                :clearable="timeType ? false : true"
                :picker-options="timeType ? pickerOptions : timeNone"
              ></el-date-picker>
            </el-form-item>
          </span>
        </el-col>
      </el-row>
      <el-row>
        <div><span class="text-buttom">常用选项</span></div>
        <el-col>
          <el-button
            type="whiteBackground"
            
            v-for="(item,index) in paymentTime"
            @click="searchName(item,index)"
            :key="item.criteriaContent"
            :class="`backPlay ${colorIndex.payTime === index ? 'colorType' : ''}`"
            >{{ item.criteriaContent }}</el-button
          >
          <el-button :type=" 'whiteBackground'"  :class="`backPlay ${colorIndex.payTime == 3 ? 'colorType' : ''}`" @click="searchName(year,4)" v-if="!timeType">近一年</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import moment from "moment";
import { debounce } from "@/utils/index";
export default {
  props: ["radio"],
  data() {
    return {
      form: {},
      buttomData: [],
      checkAll: [],
      checkStores: [],
      moreOptions: false,
      disabledStyle: false,
      disabledColor: false,
      inputData: [],
      moreOptionsIndex: 1,
      optionsn: {
        area: {commonlyUsed: []},
        bigModel: {commonlyUsed: []},
        category: {commonlyUsed: []},
        color: {commonlyUsed: []},
        functionality: {commonlyUsed: []},
        material: {commonlyUsed: []},
        price:{commonlyUsed: []},
        size: {commonlyUsed: []},
        style: {commonlyUsed: []},
      },
      // optionsn: {

      // },
      inputData: [],
      inputIndex: 50,
      dataRange: false,
      colorIndex: {
        categoryName: "",
        specDesc: "",
        saleAmountEnd: "",
        style: "",
        color: "",
        functionality: "",
        material: "",
        payTime: 2,
      },
       year: {
          criteriaContent: "近一年",
          criteriaType: 9,
          criteriaTypeDesc: "付款时间",
        },
      timeNone: {},
      pickerOptions:{
        //disabled为函数，返回值为布尔值，
          disabledDate: (time) => {
            var curDate = new Date().getTime()
            var halfYear = 365/2*24*3600*1000
            var pastResult = curDate - halfYear
            var pastDate = new Date(pastResult),
                pastYear = pastDate.getFullYear(),
                pastMonth = pastDate.getMonth() + 1,
                pastDay = new Date().getDate();
            var minYear = pastYear + '-' + pastMonth + '-' + pastDay
            if(this.timeType) {
              return time> Date.now() || time.getTime() < new Date(JSON.stringify(minYear))
            }else {
              return 
            }
            
          }
      }
    };
  },
  watch: {
    material(val) {
      let material = val.commonlyUsed.map(v=>v.criteriaContent) || []
      if(material.indexOf(this.form.material)!= -1) {
        this.colorIndex.material = material.indexOf(this.form.material)
      }else {
        this.colorIndex.material = ''
        this.$set(this.form,"material","")
      }
    },
    formData(val) {
      if (val.categoryName == "床垫") {
        this.disabledStyle = true;
        this.$set(this.form, "style", "");
      } else {
        this.disabledStyle = false;
      }
      
      if(val.categoryName != "沙发" && val.categoryName != "衣柜") {
        this.$set(this.form, "specDesc", "");
      }

      if (val.categoryName == "沙发" || val.categoryName == "床") {
        this.disabledColor = false;
      } else {
        this.disabledColor = true;
        this.$set(this.form, "color", "");
      }
      if(this.optionsn.length) {
      //   this.optionsn.category.commonlyUsed.forEach((item,index) => {
      //   if(val.categoryName == item.criteriaContent) {
      //     this.colorIndex.categoryName = index
      //   }
      // });
      let category = this.optionsn.category ? this.optionsn.category.commonlyUsed.map(v=>v.criteriaContent) : []
      if(category.indexOf(val.categoryName)!= -1) {
        this.colorIndex.categoryName = category.indexOf(val.categoryName)
      }else {
        this.colorIndex.categoryName = ''
      }

      let specDesc =  this.optionsn.specDesc ? this.optionsn.specDesc.commonlyUsed.map(v=>v.criteriaContent) : []
      if(specDesc.indexOf(val.specDesc)!= -1) {
        this.colorIndex.specDesc = specDesc.indexOf(val.specDesc)
      }else {
        this.colorIndex.specDesc = ''
      }

      let price = this.optionsn.price ? this.optionsn.price.commonlyUsed.map(v=>v.criteriaContent) : []
        let data = `${val.saleAmountStart}-${val.saleAmountEnd}`
        if(price.indexOf(data)!=-1) {
          this.colorIndex.saleAmountEnd = price.indexOf(data)
        }else if(val.saleAmountEnd <=1000 && val.saleAmountStart && val.saleAmountEnd){
          this.colorIndex.saleAmountEnd = 0
        }else if(val.saleAmountStart >5000) {
          this.colorIndex.saleAmountEnd = 5
        }else {
          this.colorIndex.saleAmountEnd = ""
        }
      // this.optionsn.style.commonlyUsed.forEach((item,index) => {
      //   if(val.style == item.criteriaContent) {
      //     this.colorIndex.style = index
      //   }
      // });
      let style = this.optionsn.style ? this.optionsn.style.commonlyUsed.map(v=>v.criteriaContent) : []
      if(style.indexOf(val.style)!= -1) {
        this.colorIndex.style = style.indexOf(val.style)
      }else {
        this.colorIndex.style = ''
      }
      // this.optionsn.size.commonlyUsed.forEach((item,index) => {
      //   if(val.productSize == item.criteriaContent) {
      //     this.colorIndex.productSize = index
      //   }
      // });

      // this.optionsn.color.commonlyUsed.forEach((item,index) => {
      //   if(val.color == item.criteriaContent) {
      //     this.colorIndex.color = index
      //   }
      // });

      let color = this.optionsn.color ? this.optionsn.color.commonlyUsed.map(v=>v.criteriaContent) : []
      if(color.indexOf(val.color)!= -1) {
        this.colorIndex.color = color.indexOf(val.color)
      }else {
        this.colorIndex.color = ''
      }

      // this.optionsn.functionality.commonlyUsed.forEach((item,index) => {
      //   if(val.functionality == item.criteriaContent) {
      //     this.colorIndex.functionality = index
      //   }
      // });

      let functionality = this.optionsn.functionality ? this.optionsn.functionality.commonlyUsed.map(v=>v.criteriaContent) : []
      if(functionality.indexOf(val.functionality)!= -1) {
        this.colorIndex.functionality = functionality.indexOf(val.functionality)
      }else {
        this.colorIndex.functionality = ''
      }

      // this.optionsn.material.commonlyUsed.forEach((item,index) => {
      //   if(val.material == item.criteriaContent) {
      //     this.colorIndex.material = index
      //   }
      // });

      let material = this.optionsn.material ? this.optionsn.material.commonlyUsed.map(v=>v.criteriaContent) : []
      if(material.indexOf(val.material)!= -1) {
        this.colorIndex.material = material.indexOf(val.material)
      }else {
        this.colorIndex.material = ''
      }
      }

        //近一周
        let week = moment(new Date())
          .subtract(1, "weeks")
          .subtract(-1, "days")
          .format("YYYY-MM-DD");
        //近30天
        let day = moment(new Date())
          .subtract(30, "days")
          .subtract(-1, "days")
          .format("YYYY-MM-DD");
        //近半年时间
        let month = moment(new Date())
          .subtract(6, "months")
          .format("YYYY-MM-DD");
        //近一年
        let year = moment(new Date())
          .subtract(1, "years")
          .format("YYYY-MM-DD");
        //当前时间
        let time = moment(new Date()).subtract("months").format("YYYY-MM-DD");
        if(val.payTimeStart>= week && val.payTimeEnd<= time && week <=val.payTimeEnd) {
          this.colorIndex.payTime = 0
        }else if(val.payTimeStart>= day && val.payTimeEnd<= time && day <=val.payTimeEnd) {
          this.colorIndex.payTime = 1
        }else if(val.payTimeStart>= month && val.payTimeEnd<= time && month <=val.payTimeEnd) {
          this.colorIndex.payTime = 2
        }else if(val.payTimeStart>= year && val.payTimeEnd<= time && year <=val.payTimeEnd) {
          this.colorIndex.payTime = 3
        }else {
          this.colorIndex.payTime = ""
        }
    },
  },
  computed: {
    butoomNameList() {
      let categoryName = [
        { name: "床" },
        { name: "床垫" },
        { name: "沙发" },
        { name: "茶店" },
        { name: "衣柜" },
        { name: "意式" },
        { name: "餐座椅" },
      ];
      let priceList = [
        { name: "1000以下" },
        { name: "1000~2000" },
        { name: "2000~3000" },
        { name: "3000~4000" },
        { name: "4000~5000" },
        { name: "5000以上" },
      ];
      let styleList = [
        { name: "北欧" },
        { name: "简约" },
        { name: "现代" },
        { name: "轻奢" },
        { name: "田园" },
        { name: "意式" },
        { name: "中式" },
      ];
      let productSizeList = [
        { name: "1800mm" },
        { name: "1500mm" },
        { name: "1400mm" },
      ];
      let colorList = [
        { name: "灰色" },
        { name: "蓝色" },
        { name: "米色" },
        { name: "咖色" },
      ];
      let functionalityList = [{ name: "储物" }, { name: "伸缩" }];
      let materialList = [
        { name: "实木" },
        { name: "板木" },
        { name: "板式" },
        { name: "布" },
        { name: "皮" },
        { name: "岩板" },
      ];
      let paymentTime = [
        { name: "近一周" },
        { name: "近30天" },
        { name: "近半年" },
        { name: "近一年" },
      ];
      return [
        priceList,
        categoryName,
        styleList,
        productSizeList,
        colorList,
        functionalityList,
        materialList,
        paymentTime,
      ];
    },
    formData() {
      let data = JSON.parse(JSON.stringify(this.form));
      return data;
    },
    material() {
      let data = JSON.parse(JSON.stringify(this.optionsn.material));
      return data;
    },
    paymentTime() {
      let data = [
        {
          criteriaContent: "近一周",
          criteriaType: 9,
          criteriaTypeDesc: "付款时间",
        },
        {
          criteriaContent: "近30天",
          criteriaType: 9,
          criteriaTypeDesc: "付款时间",
        },
        {
          criteriaContent: "近半年",
          criteriaType: 9,
          criteriaTypeDesc: "付款时间",
        },
      ];
      return data;
    },
    queryContent() {
      let name = [];
      if (this.form.categoryName) {
        name.push({ name: `类别：${this.form.categoryName}`, type: 1 });
      }
      if (this.form.specDesc) {
        name.push({ name: `规格：${this.form.specDesc}`, type: 2 });
      }
      if (this.form.saleAmountStart) {
        if (this.form.saleAmountEnd) {
          name.push({
            name: `金额：${this.form.saleAmountStart} ~ ${this.form.saleAmountEnd}`,
            type: 3,
          });
        } else {
          name.push({
            name: `金额：${this.form.saleAmountStart}以上`,
            type: 3,
          });
        }
      }
      if (this.form.style) {
        name.push({ name: `风格：${this.form.style}`, type: 4 });
      }
      // if (this.form.length) {
      //   name.push({ name: `长：${this.form.length}`, type: 5 });
      // }
      if (this.form.lengthUpper) {
        if(this.form.lengthLower) {
          name.push({ name: `长：${this.form.lengthUpper} ~ ${this.form.lengthLower}`, type: 5 });
        }else {
          name.push({ name: `长：${this.form.lengthUpper}`, type: 5 });
        }
      }
      // if (this.form.width) {
      //   name.push({ name: `宽：${this.form.width}`, type: 6 });
      // }
      if (this.form.widthUpper) {
        if(this.form.widthLower) {
          name.push({ name: `宽：${this.form.widthUpper} ~ ${this.form.widthLower}`, type: 6 });
        }else {
          name.push({ name: `宽：${this.form.widthUpper}`, type: 6 });
        }
      }
      // if (this.form.height) {
      //   name.push({ name: `高：${this.form.height}`, type: 7 });
      // }
      if (this.form.heightUpper) {
        if(this.form.heightLower) {
          name.push({ name: `高：${this.form.heightUpper} ~ ${this.form.heightLower}`, type: 6 });
        }else {
          name.push({ name: `高：${this.form.heightUpper}`, type: 6 });
        }
      }
      if (this.form.color) {
        name.push({ name: `颜色：${this.form.color}`, type: 8 });
      }
      if (this.form.functionality) {
        name.push({ name: `功能：${this.form.functionality}`, type: 9 });
      }
      if (this.form.material) {
        name.push({ name: `材质：${this.form.material}`, type: 10 });
      }
      if (this.form.province.length) {
        name.push({ name: `地域：${this.form.province}`, type: 11 });
      }
      if (this.form.payTimeStart) {
        name.push({
          name: `付款时间：${this.form.payTimeStart} - ${this.form.payTimeEnd}`,
          type: 12,
        });
      }
      return name;
    },
    timeType() {
      if(!this.dataRange && this.form.payTimeStart < moment(new Date()).subtract(6, "months").format("YYYY-MM-DD")) {
        this.$set(
          this.form,
          "payTimeStart",
          moment(new Date())
            .subtract(6, "months")
            .format("YYYY-MM-DD")
        );
        return true
      }else if(!this.dataRange && this.form.payTimeStart <= moment(new Date()).subtract(6, "months").format("YYYY-MM-DD")) {
        return true
      }else if(this.dataRange) {
        return false
      }else {
        return true
      }
    },
  },
 async mounted() {
    await this.getOptionsn();
    this.$bus.$on("timeType", (data) => {
      this.dataRange = data
    });
    // this.init();
    this.$set(
      this.form,
      "payTimeEnd",
      moment(new Date()).subtract("months").format("YYYY-MM-DD")
    );
    this.$set(
      this.form,
      "payTimeStart",
      moment(new Date())
        .subtract(6, "months")
        .format("YYYY-MM-DD")
    );
  },
  methods: {
    work() {
      console.log(this.timeType);
      console.log(this.dataRange);
    },
    more() {
      this.moreOptionsIndex += 1;
      if (this.moreOptionsIndex % 2 == 0) {
        this.moreOptions = true;
      } else {
        this.moreOptions = false;
      }
    },
    TagCloseInput(data) {
      if (!data.includes(1)) {
        this.form.categoryName = "";
        this.colorIndex.categoryName = "";
      }
      if (!data.includes(2)) {
        this.form.specDesc = "";
        this.colorIndex.specDesc = "";
      }
      if (!data.includes(3)) {
        this.form.saleAmountStart = "";
        this.form.saleAmountEnd = "";
        this.colorIndex.saleAmountEnd = "";
      }
      if (!data.includes(4)) {
        this.form.style = "";
        this.colorIndex.style = "";
      }
      if (!data.includes(5)) {
        // this.form.length = "";
        this.form.lengthUpper = "";
        this.form.lengthLower = "";
      }
      if (!data.includes(6)) {
        // this.form.width = "";
        this.form.widthUpper = "";
        this.form.widthLower = "";
      }
      if (!data.includes(7)) {
        // this.form.height = "";
        this.form.heightUpper = "";
        this.form.heightLower = "";
      }
      if (!data.includes(8)) {
        this.form.color = "";
        this.colorIndex.color = "";
      }
      if (!data.includes(9)) {
        this.form.functionality = "";
        this.colorIndex.functionality = "";
      }
      if (!data.includes(10)) {
        this.form.material = "";
        this.colorIndex.material = "";
      }
      if (!data.includes(11)) {
        this.form.province = [];
      }
      if (!data.includes(12)) {
        this.$set(
          this.form,
          "payTimeEnd",
          moment(new Date()).subtract("months").format("YYYY-MM-DD")
        );
        this.$set(
          this.form,
          "payTimeStart",
          moment(new Date())
            .subtract(6, "months")
            .format("YYYY-MM-DD")
        );
        this.colorIndex.payTime = 2;
      }
      this.getOptionsn(this.form)
    },

    // handleChange() {
    //   // if (this.checkStores.length > 1) {
    //   //   this.checkStores.shift();
    //   // }
    //   this.$set(this.form, "province", this.checkStores)
    //   // this.$set(this.form, "province", this.checkStores[0])
    // },
    // async init() {
    //   this.tableData = this.tableDataList;
    //   this.$q.intelligentRecom
    //     .getSearchConfigs({})
    //     .then((res) => {
    //       if (res.code == 200) {
    //         this.buttomData = res.data;
    //       } else {
    //         // this.tableData = [];
    //       }
    //     })
    //     .finally((_) => {
    //       this.loading = false;
    //     });
    // },

    onSubmit: debounce(function () {
      this.$emit("keyupEnter", this.form);
    }, 500),

    onSkuCodeFocus(index) {
      this.inputIndex = index
      if (index == 7) {
        this.inputData = this.optionsn.length;
      } else if (index == 2) {
        this.inputData = this.optionsn.color;
      } else if (index == 3) {
        this.inputData = this.optionsn.material;
      } else if (index == 4) {
        this.inputData = this.optionsn.style;
      } else if (index == 5) {
        this.inputData = this.optionsn.category;
      } else if (index == 6) {
        this.inputData = this.optionsn.functionality;
      }else if(index == 8) {
        this.inputData = this.optionsn.width;
      }else if(index == 9) {
        this.inputData = this.optionsn.height;
      }else if(index == 10) {
        if(this.form.categoryName == '沙发') {
           this.inputData = this.optionsn.sofaSpec;
        }else if(this.form.categoryName == '衣柜') {
          this.inputData = this.optionsn.wardrobeSpec;
        }
        
      }
    },
    queryStringFales(queryString,cb) {
      this.$q.intelligentRecom
        .optionsn({ data: this.form})
        .then((res) => {
          this.optionsn = res.data;
          if (this.inputIndex == 7) {
        this.inputData = this.optionsn.length;
        console.log(this.inputData);
      } else if (this.inputIndex == 2) {
        this.inputData = this.optionsn.color;
      } else if (this.inputIndex == 3) {
        this.inputData = this.optionsn.material;
      } else if (this.inputIndex == 4) {
        this.inputData = this.optionsn.style;
      } else if (this.inputIndex == 5) {
        this.inputData = this.optionsn.category;
      } else if (this.inputIndex == 6) {
        this.inputData = this.optionsn.functionality;
      }else if(this.inputIndex == 8) {
        this.inputData = this.optionsn.width;
      }else if(this.inputIndex == 9) {
        this.inputData = this.optionsn.height;
      }else if(this.inputIndex == 10) {
        if(this.form.categoryName == '沙发') {
           this.inputData = this.optionsn.sofaSpec;
        }else if(this.form.categoryName == '衣柜') {
          this.inputData = this.optionsn.wardrobeSpec;
        }
        
      }
        let data = this.inputData;
        if (!data || !data.allOptions) {
          cb([]);
          return;
        }
      let results = queryString
        ? data.allOptions
            .map((v) => v.criteriaContent)
            .filter((item) =>
              item.toLowerCase().includes(queryString.toLowerCase())
            )
        : data.allOptions
        ? data.allOptions
            .filter((v) => !v.useFlag)
            .map((v) => v.criteriaContent)
        : [];
      if (!results || !results.length) {
        cb([]);
        return;
      }
      
      results = results.map((item) => ({
        ...item,
        value: item,
      }));
      console.log(results);
      // 调用 callback 返回建议列表的数据
      cb(results);
        })
        .finally((_) => {
          
        });
    },

    queryStringTrue(queryString, cb) {
      let data = this.inputData;
      if (!data || !data.allOptions) {
        cb([]);
        return;
      }
      let results = queryString
        ? data.allOptions
            .map((v) => v.criteriaContent)
            .filter((item) =>
              item.toLowerCase().includes(queryString.toLowerCase())
            )
        : data.allOptions
        ? data.allOptions
            .filter((v) => !v.useFlag)
            .map((v) => v.criteriaContent)
        : [];
      if (!results || !results.length) {
        cb([]);
        return;
      }
      this.getCategoryMappingBigModel()
      results = results.map((item) => ({
        ...item,
        value: item,
      }));
      // 调用 callback 返回建议列表的数据
      cb(results);
    },

     querySkuList(queryString, cb) {
      if(queryString) {
        this.queryStringTrue(queryString, cb)
      }else {
        this.queryStringFales(queryString, cb)
      }
    },

    // querySkuList(queryString, cb) {
    //   let data = this.inputData;
    //   if (!data) {
    //     cb([]);
    //     return;
    //   }
    //   let results = queryString
    //     ? data.allOptions
    //         .map((v) => v.criteriaContent)
    //         .filter((item) =>
    //           item.toLowerCase().includes(queryString.toLowerCase())
    //         )
    //     : data.commonlyUsed
    //     ? data.commonlyUsed.filter(v=>!v.useFlag).map((v) => v.criteriaContent)
    //     : [];
    //   results = results.map((item) => ({
    //     ...item,
    //     value: item,
    //   }));
    //   // 调用 callback 返回建议列表的数据
    //   cb(results);
    // },

    //匹配前面数据
    querySkuProductSize(queryString, cb) {
      let data = this.inputData;
      if(!data || !data.allOptions) {
        cb([])
        return
      } 
      let results = queryString
        ? data.allOptions
            .map((v) => v.criteriaContent)
            .filter(
              (item) =>
                item.toLowerCase().substr(0, queryString.length) == queryString
            )
        : data.commonlyUsed
        ? data.commonlyUsed.filter(v=>!v.useFlag).map((v) => v.criteriaContent)
        : [];
      results = results.map((item) => ({
        ...item,
        value: item,
      }));
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    getOptionsn(data) {
      this.$q.intelligentRecom.optionsn({data:data|| {}}).then((res) => {
        this.$nextTick(_=>{
          this.optionsn = res.data;
          console.log(this.optionsn);
        })
      });
    },
    searchName(item, index) {
      if (item.criteriaTypeDesc == "类别") {
        this.colorIndex.categoryName = index;
        this.$set(this.form, "categoryName", item.criteriaContent);
      } else if (item.criteriaTypeDesc.includes('规格')) {
        this.colorIndex.specDesc = index;
        this.$set(this.form, "specDesc", item.criteriaContent);
      } else if (item.criteriaTypeDesc == "金额") {
        this.colorIndex.saleAmountEnd = index;
        if (item.criteriaContent == "1000以下") {
          this.$set(this.form, "saleAmountStart", "0");
          this.$set(this.form, "saleAmountEnd", "1000");
        } else if (item.criteriaContent == "5000以上") {
          this.$set(this.form, "saleAmountStart", "5000");
          this.$set(this.form, "saleAmountEnd", "");
        } else {
          let saleAmount = item.criteriaContent.substring(
            0,
            item.criteriaContent.length - 5
          );
          let moneyEnd = item.criteriaContent.slice(5);
          this.$set(this.form, "saleAmountStart", saleAmount);
          this.$set(this.form, "saleAmountEnd", moneyEnd);
        }
      } else if (item.criteriaTypeDesc == "风格") {
        this.colorIndex.style = index;
        if (!this.disabledStyle) {
          this.$set(this.form, "style", item.criteriaContent);
        } else {
          this.$set(this.form, "style", "");
        }
      } else if (item.criteriaTypeDesc == "颜色") {
        this.colorIndex.color = index;
        if (!this.disabledColor) {
          this.$set(this.form, "color", item.criteriaContent);
        } else {
          console.log(1);
          this.$set(this.form, "color", "");
        }
      } else if (item.criteriaTypeDesc == "功能") {
        this.colorIndex.functionality = index;
        this.$set(this.form, "functionality", item.criteriaContent);
      } else if (item.criteriaTypeDesc == "材质") {
        this.colorIndex.material = index;
        this.$set(this.form, "material", item.criteriaContent);
      } else if (item.criteriaTypeDesc == "付款时间") {
        this.colorIndex.payTime = index;
        let week = moment(new Date())
          .subtract(1, "weeks")
          .subtract(-1, "days")
          .format("YYYY-MM-DD");
        let day = moment(new Date())
          .subtract(30, "days")
          .subtract(-1, "days")
          .format("YYYY-MM-DD");
        let month = moment(new Date())
          .subtract(6, "months")
          .format("YYYY-MM-DD");
        let year = moment(new Date())
          .subtract(1, "years")
          .format("YYYY-MM-DD");
        let time = moment(new Date()).subtract("months").format("YYYY-MM-DD");
        if (item.criteriaContent == "近一周") {
          this.$set(this.form, "payTimeStart", week);
        } else if (item.criteriaContent == "近30天") {
          this.$set(this.form, "payTimeStart", day);
        } else if (item.criteriaContent == "近半年") {
          this.$set(this.form, "payTimeStart", month);
        } else {
          this.$set(this.form, "payTimeStart", year);
        }
        this.$set(this.form, "payTimeEnd", time);
      }
      this.getOptionsn(this.form)
    },
    getCategoryMappingBigModel() {
      setTimeout(_=>{
        this.getOptionsn(this.form)
      },200)
    }
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-form-item__label {
  width: 135px !important;
  font-size:  15px;
  color: #ff8900;
  font-weight: 800;
}

>>> .el-row {
  display: flex;
  flex-wrap: nowrap;
  min-height: 30px;
}

.text-buttom {
  display: inline-block;
  width:124px;
  padding-top: 5px;
  height: 100%;
  text-align: right;
  padding-right: 12px;
  // &::before {
  // content: '';
  // padding-right: 30px;
  // }
}

>>> .el-input--small .el-input__inner {
  height: 28px;
}

>>> .form-number-input .date-number-middle .el-form-item__label {
  width: 20px !important;
}

>>> .el-button {
  font-size: 0.729vw;
}

>>> .el-button+.el-button {
  margin-left: 0px;
  margin-right: 15px;
  margin-bottom: 10px;
  font-size: 0.729vw;
}

>>> .el-button+.el-button:nth-child(2) {
  margin-left: 15px;
  margin-bottom: 10px;
  font-size: 0.729vw;
}

>>> .checkbox .el-checkbox {
  width: 140px;
}

>>> .form-number-input {
  height: 50px;
}

>>> .el-form--inline .el-form-item {
  height: 30px;
}

>>> .el-card__body .el-form-item {
  height: auto;
}

>>> .province .el-form-item {
  height: auto;
  margin: 8px 10px 8px 0;
}

>>> .province .el-input__suffix {
  line-height: 28px
}

.backPlay {
  &:hover {
    background-color: #0BB78E;
    border-color: #0BB78E;
    color: #fff;
  }
}

.colorType {
  background-color: #0BB78E !important;
  border-color: #0BB78E !important;
  color: #fff !important;
}

.el-button--whiteBackground {
  font-size: 0.729vw;
  // font-size: 12px;
  color: #000;
  background-color: #F6F4F4;
  border-color: #F6F4F4;
}
</style>
